/* Components */
import Header from "../../components/common/Header";
import ViewFunerariumGeneralInfos from "./funerarium/ViewFunerariumGeneralInfos";
import ViewFunerariumAddress from "./funerarium/ViewFunerariumAddress";
import ViewFunerariumSchedule from "./funerarium/ViewFunerariumSchedule";
import {getFunerariumGeneralInfos} from "../../api/pro/funerariumReq";
import useData from "../../hooks/useData";
import useAuth from "../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import {useEffect, useRef} from "react";


export default function ViewFunerarium() {
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;
    const { funerariumInfos, setFunerariumInfos } = useData();
    const hasFetchedRef = useRef(false);

    const apiFunerariumGeneralInfos = async () => {
        const response = await getFunerariumGeneralInfos(token, agencyId);
        setFunerariumInfos(response);
    }

    // Charger une seule fois au montage : quand l'agence n'a pas encore de funérarium configuré,
    // le backend renvoie [] (nouvelle référence à chaque appel), ce qui faisait reboucler cet
    // effet indéfiniment avec l'ancienne condition `funerariumInfos?.length < 1`.
    useEffect(() => {
        if (!hasFetchedRef.current) {
            hasFetchedRef.current = true;
            apiFunerariumGeneralInfos();
        }
    }, []);

    return (
        <main>
            <Header parent="Funerarium"
                    location="Le funérarium"
                    slug={`/funerarium/`}
            />
            <ViewFunerariumGeneralInfos apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} legend="Funérarium"/>
            <ViewFunerariumAddress apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} legend="Adresse"/>
            <ViewFunerariumSchedule apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} legend="Horaires d'ouverture"/>
        </main>
    )
}